"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const RadioField = (props) => {
    return ((0, jsx_runtime_1.jsx)("input", { id: props.id, name: props.name, type: 'radio', checked: props.checked, defaultChecked: props.defaultChecked, disabled: props.disabled, onChange: val => props.onChange(props.name, parseInt(val.target.value)), value: props.value, className: props.className }));
};
exports.default = RadioField;
